import React, { Fragment, useEffect, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@material-ui/core'

import { CheckBox } from '@/components'
import { useCurrentForm } from '@/components/CoForm'
import { getCompaniesRequest } from '@/store/modules/admin/companies/reducer'
import formatter from '@/services/formatter'
import SearchInput from '@/components/SearchInput'

export function SpecialCompanies({ name }) {
  const dispatch = useDispatch()
  const [searchTerm, setSearchTerm] = useState('')

  const loading = useSelector((state) => state.admin.companies.loading)
  const companies = useSelector((state) => state.admin.companies.webCompanies)

  const { getFieldValue, setFieldValue, errors } = useCurrentForm()

  const selectedCompanies = getFieldValue(name) || []
  const errorMessage = errors?.[name]

  useEffect(() => {
    dispatch(getCompaniesRequest())
  }, [dispatch])

  useEffect(() => {
    if (companies.length) {
      const preselected = companies
        .filter((company) => company.wee_especial)
        .map((c) => c.id)
      setFieldValue(name, preselected)
    }
  }, [companies, name])

  function handleSelectCompany(companyId, checked) {
    const updated = checked
      ? [...selectedCompanies, companyId]
      : selectedCompanies.filter((id) => id !== companyId)

    setFieldValue(name, updated)
  }

  const handleSearch = (term) => {
    setSearchTerm(term?.toLowerCase() || '')
  }

  const filteredCompanies = useMemo(() => {
    if (!searchTerm) return companies
    return companies.filter((company) =>
      company.company.emp_razao_social.toLowerCase().includes(searchTerm)
    )
  }, [companies, searchTerm])

  return (
    <Box maxHeight={320} overflow="auto" px="1rem">
      <List dense>
        <ListItem style={{ marginTop: '1rem' }}>
          <ListItemText
            style={{ margin: 0, padding: 0 }}
            secondary="Selecione as transportadoras que deseja isentar das cotas."
          />
        </ListItem>

        <Box mb={1}>
          <SearchInput
            placeholder="Buscar transportadora..."
            onSearch={handleSearch}
            fullWidth
            variant="outlined"
            size="small"
          />
        </Box>
        <Divider component="li" />

        {filteredCompanies.map((webCompany) => {
          const companyId = webCompany.id
          const isChecked = selectedCompanies.includes(companyId)

          return (
            <Fragment key={`web-company-${companyId}`}>
              <ListItem disabled={loading}>
                <CheckBox
                  onChange={(_, checked) =>
                    handleSelectCompany(companyId, checked)
                  }
                  checked={isChecked}
                  edge="start"
                  disableRipple
                />
                <ListItemText
                  primary={webCompany.company.emp_razao_social}
                  secondary={formatter(webCompany.company.id).toCNPJ()}
                />
              </ListItem>
              <Divider component="li" />
            </Fragment>
          )
        })}
      </List>

      {errorMessage && (
        <Typography color="error" variant="caption" gutterBottom>
          {errorMessage}
        </Typography>
      )}
    </Box>
  )
}
